import React, { useState, useEffect } from 'react'
import { countdownTargetDate } from '../../../utility'
import './Countdown.css'
import { useSelector } from 'react-redux'
import props from '../../../redux/props'

const Countdown = () => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const calculateTimeLeft = () => {
    const difference = countdownTargetDate.getTime() - new Date().getTime()
    let timeLeft = {
      days: '00',
      hours: '00',
      minutes: '00',
    }

    if (difference > 0) {
      timeLeft = {
        days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, '0'),
        hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, '0'),
        minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(2, '0'),
      }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    return () => clearTimeout(timer)
  })

  return (
    <div className="countdown">
      <div className="countdown-item">
        <div className="flap">{timeLeft.days || '0'}</div>
        <div className="label">{t.cubePopup.days}</div>
      </div>
      <div className="countdown-item">
        <div className="flap">{timeLeft.hours || '0'}</div>
        <div className="label">{t.cubePopup.hours}</div>
      </div>
      <div className="countdown-item">
        <div className="flap">{timeLeft.minutes || '0'}</div>
        <div className="label">{t.cubePopup.minutes}</div>
      </div>
    </div>
  )
}

export default Countdown
